import React, { useEffect } from "react";
import queryString from "query-string";
import { sanitizeUrl } from "@braintree/sanitize-url";
import Routes from "./Routes";
import { getCookies, setCookie } from "./utils/cookies";
import i18n from "./i18n";

function App() {
  useEffect(() => {
    const params = queryString.parse(sanitizeUrl(window.location.href).split("?")[1]);
    const urlParam = params.language;
    const isSupportedLanguage = ["en_US", "es"].includes(urlParam);
    const languageCookie = getCookies("ctsessionlanguage");
    let setLangugae = "en_US";
    if (
      urlParam &&
      languageCookie &&
      urlParam === languageCookie &&
      isSupportedLanguage
    ) {
      setLangugae = urlParam;
    } else if (
      ((urlParam && languageCookie && urlParam !== languageCookie) ||
        (urlParam && !languageCookie)) &&
      isSupportedLanguage
    ) {
      setLangugae = urlParam;
      setCookie("ctsessionlanguage", urlParam);
    } else if (
      (!urlParam && languageCookie && isSupportedLanguage) ||
      (!isSupportedLanguage && languageCookie)
    ) {
      setLangugae = languageCookie;
    }
    i18n.changeLanguage(setLangugae);

    window.addEventListener("keydown", () => {
      document.body.classList.remove('mouseFocus');
    });
    window.addEventListener("mousedown", () => {
      document.body.classList.add('mouseFocus');
    });
  }, []);

  return (
    <>
      <div className="loader hide" />
      <Routes />
    </>
  );
}

export default App;
